module.exports = __webpack_public_path__ + "static/shape-five-4dcc678d6c4b57fdbfd96300b6125862.png";